export default __webpack_public_path__ + "static/media/moon.fdf2eb9f.jpeg";